import { BaseComponent } from '../BaseComponent'
import { IconHelper } from '@/core/utils'

import template from './template.html?raw'
import styles from './style.scss?inline'

export default class SpeedOptionsComponent extends BaseComponent
{
  private readonly iconContainer: HTMLElement
  private speedButton: HTMLElement
  private speedOptions: HTMLElement

  constructor()
  {
    super()
    this.render(template, styles)

    this.speedButton = this.shadow.querySelector('.j-speed')!
    this.speedOptions = this.shadow.querySelector('.j-speed-options')!
    this.iconContainer = this.shadow.querySelector('.icon-container')!

    this.speedButton.addEventListener('click', () => {
      this.speedOptions.classList.toggle('show')
    })

    this.speedOptions.addEventListener('click', (event) => {
      const target = event.target as HTMLElement

      if (target.tagName === 'LI') {
        const speed = parseFloat(target.dataset.speed || '1')
        this.emit('speedchange', { speed })
        this.speedOptions.classList.remove('show')
      }
    })
  }

  connectedCallback()
  {
    IconHelper.loadIcons().then(() => {
      IconHelper.insertIcon(this.iconContainer, 'slow-motion')
    })
  }

  public updateActiveOption(speed: number): void
  {
    this.speedOptions.querySelectorAll('li').forEach(option => {
      option.classList.toggle('active', parseFloat(option.dataset.speed || '1') === speed)
    })
  }
}
